import React, { useContext } from 'react';
import ThrottlingCheckbox from 'integrations/components/ThrottlingCheckbox';
import AdditionalFields from 'integrations/aws/common/AdditionalFields';
import FormDataContext from 'integrations/contexts/FormDataContext';

import { Input } from 'components/bootstrap';

import { AdvancedOptionsContext } from './context/AdvancedOptions';
import type { HandleFieldUpdateType, AdvancedOptionsContextType } from './types';

interface Props {
  onChange: HandleFieldUpdateType;
}

const containerStyle = {
  display: 'flex',
};

const hoursStyle = {
  paddingTop: '30px',
  paddingLeft: '10px',
  fontWeight: 'bold',
} as const;

const FormAdvancedOptions = ({ onChange }: Props) => {
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } =
    useContext<AdvancedOptionsContextType>(AdvancedOptionsContext);

  const { salesforceThrottleEnabled, accessTokenExpiresIn } = formData;

  const handleToggle: (visible: boolean) => void = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };

  return (
    <AdditionalFields title="Advanced Options" visible={isAdvancedOptionsVisible} onToggle={handleToggle}>
      <ThrottlingCheckbox
        id="salesforceThrottleEnabled"
        defaultChecked={salesforceThrottleEnabled?.value}
        onChange={onChange}
      />
      <div style={containerStyle}>
        <Input
          id="accessTokenExpiresIn"
          name="accessTokenExpiresIn"
          type="number"
          value={accessTokenExpiresIn.value || accessTokenExpiresIn.defaultValue || ''}
          min="1"
          step="1"
          onChange={onChange}
          required
          help="Determines how often (in hours) the Salesforce API access token will expire. Default value is 1 hour."
          label="Salesforce Access Token Expires In"
        />
        <span style={hoursStyle}>Hours</span>
      </div>
    </AdditionalFields>
  );
};

export default FormAdvancedOptions;
